

import React, { useState, useEffect, useRef } from 'react'
import '../assets/styles/modal.scss'
import closeIcon from '../images/icons/Icon2.png'
import { Input } from "./Input"
import downloadMasterIcon from '../assets/icons/download-master.svg';
import imageThumb from "../assets/imageThumb.svg"
import { HOST_SERVER } from '../utils/configs';
import ReactPdfViewer from '../utils/pdfViewer';
import useSidebarHidden from "../common/useSidebarHidden";
import LoadingIn from '../assets/loadingIn.gif';
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import dimensionCuboid from '../assets/icons/dimension-cuboid.svg';
import dimensionCylindrical from '../assets/icons/dimension-cylindrical.svg';

const CUBIC_VOLUME_UNITS = { cm: 'cm3', in: 'in3', mm: 'mm3' };

export const Modal = (props) => {

  const TitleComponent = props.TitleComponent;
  const fileInput = useRef(null)
  const showDone = props.showDone !== undefined ? props.showDone : true;
  const showFieldsInColumn = props.showFieldsInColumn || false;
  const modalCustomButtons = props.modalCustomButtons || [];
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const sideBarHidden = useSidebarHidden('.content-container');

  const handleImageUpload = (e, title) => {
    title !== 'Create Invoice' ? props.encodeImageFileAsURL(e.target.files[0]) : handlePdfUpload(e)

  }
  const handlePdfUpload = (e) => {
    setSelectedPdf(e.currentTarget.files[0])
  }

  let isError = false,
    isNotify = false,
    updateStatusText = '';

  if (props.modalFormStatusObj) {
    if (('text' in props.modalFormStatusObj)) {
      updateStatusText = props.modalFormStatusObj.text;
    }
    if (('error' in props.modalFormStatusObj)) {
      updateStatusText = props.modalFormStatusObj.error;
      isError = props.modalFormStatusObj.error;
    }
    if (('notification' in props.modalFormStatusObj)) {
      updateStatusText = props.modalFormStatusObj.notification;
      isNotify = props.modalFormStatusObj.notification;
    }
  };

  const decrementPageNo = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const incrementPageNo = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };
  const getDatasetAtEvent = (data) => {

    // Check value flag only when required is true; if required is false, ignore value
    const hasRequiredPropsValue = data[0].every(val => {
      if (val?.props?.required) {
        return !!val?.props?.value;
      }
      return true;
    });
    return !hasRequiredPropsValue;
  }
  const isButtonDefined = (button) => {
    if (typeof button === 'object' && Object.keys(button).length > 0) {
      return true;
    }
    else if (button.length > 0) {
      return true;
    }
    return false;
  };

  // Function to get the button content , this is added to avoid more nested inline conditions.
  const getButtonContent = (button) => {
    const isGRNModal = props.title.includes("GRN -");
    const isDownloadButton = button.label === "Download";

    if (isGRNModal) {
      if (!props.showLoadingBtn) {
        return (
          <>
            <span>
              <img
                className="icon-size mt-1"
                alt="downloadMaster"
                src={downloadMasterIcon}
              />
            </span>
            {" "}Download
          </>
        );
      }

      return (
        <div className="flexRow justifyContentCenter alignItemsCenter">
          <img
            src={LoadingIn}
            style={{ marginRight: "5px", width: "35px", height: "35px" }}
            alt="Loading"
          />
          {" "}Processing...
        </div>
      );
    }


    if (isDownloadButton) {
      if (props.showLoadingBtn) {
        return (
          <div className="flexRow justifyContentCenter alignItemsCenter">
            <img
              src={LoadingIn}
              style={{ marginRight: "5px", width: "25px", height: "25px" }}
              alt="Loading"
            />
            {" "}Processing...
          </div>
        );
      }

      return (
        <div className='flexRow justifyContentCenter alignItemsCenter'>
          <img
            className="icon-size mt-1"
            alt="downloadMaster"
            src={downloadMasterIcon}
          />
          {" "}Download
        </div>
      );
    }


    if (button.label !== "Cancel" && props.showLoadingBtn) {
      return button.loadingStateLabel || "Updating...";
    }

    return button.label || "Okay";
  };


  return (
    <div className={`overlay ${props.isSubModal ? 'sub' : ''} ${props.overlayClassName || ''}`} role="dialog">
      <div className={`${(props?.overlayClassName || sideBarHidden) ? 'dialog-fs2' : 'dialog'} sm-scrollbar`} style={!sideBarHidden ? props.customModalStyle : undefined}>
        <div className={`dialog__content ${props.className || ''}`}>
          <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
            <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width50">{typeof props.title === "string" && props.title}
              {Boolean(TitleComponent) && <TitleComponent />}</h2>
            <button className='close-btn-ht' onClick={props.onClose}>
              <img src={closeIcon} alt="close" data-icon='close' />
            </button>
          </div>
          <hr />
          {!showFieldsInColumn ?
            <div style={props.customContentHeight} className={`dialog__body_container flexRow ${props.title?.includes('Pilferage') || props.title?.includes('-Items') || props.title?.includes('Device Details') || props.mainContentCenter ? 'justifyContentCenter' : props.alignStart ? "justifyContentFlexStart gap20" : 'justifyContentSpaceBetween'} flexWrap`}>
              {props.children}
            </div>
            :
            <div className={`dialog__body_container flexCol ${!props.columnViewType ? 'alignItemsCenter' : ''}`} style={props.customContentHeight} >{props.children}</div>
          }

          {props.blobFile || props.imageUrl ? <div className="formGroup__formHorizontal"><img src={props.blobFile ? props.blobFile : `${HOST_SERVER}/${props.imageUrl}`} className="img-thumbnail" alt='' width="90" height="60" /> <img className="image__close__icon" alt='Close' src={closeIcon} onClick={() => props.resetImageSelection(true)} /><p className="pvm__text-center">{props.fileUpload?.name ? props.fileUpload?.name : ''}</p></div> : <></>}
          {selectedPdf ? <ReactPdfViewer fileHolder={selectedPdf} numPages={numPages} pageNumber={pageNumber} setNumPages={setNumPages} setPageNumber={setPageNumber} /> : <></>}
          {selectedPdf ? <div className='flexRow  alignItemsCenter justifyContentCenter margTop10'><span className='pointer'>{pageNumber !== 1 ? <FaChevronCircleLeft size={25} onClick={decrementPageNo} /> : <></>}&nbsp;Page {pageNumber} of {numPages}</span>&nbsp;<span className='pointer'>{pageNumber !== numPages ? <FaChevronCircleRight onClick={incrementPageNo} size={25} /> : <></>}</span></div> : <></>}

          {Boolean(updateStatusText) &&
            <div className={"dialog__statusBlock " + (isError ? 'alert_error' : isNotify ? 'alert_notify' : 'alert_success')}>
              {updateStatusText}
            </div>}

          {modalCustomButtons.length > 0 ?
            <>
              <div className={`dialog__footer flexRow ${props.title.includes('GRN -') ? "justifyContentFlexStart" : "justifyContentSpaceEvenly"}`}>
                {modalCustomButtons.map((button, i) => {
                  return isButtonDefined(button) ?
                    <button
                      key={i}
                      className={`done-button ${button.disabled || props.showLoadingBtn ? 'button_inrt' : ''} ${button.className}`}
                      disabled={button.disabled || props.showLoadingBtn || false}
                      style={button.style || {}}
                      onClick={
                        typeof button.action === 'function' ?
                          button.action :
                          props.onSubmit
                      }
                    >
                      {getButtonContent(button)}
                    </button>
                    : null
                })
                }
              </div>
            </>
            :
            <>
              {props.title === "Edit Item" || props.title === "Add Item" || props.title === "Create Invoice" ?
                <div className="dialog__footer flexCol alignItemsCenter">
                  <>
                    <input
                      ref={fileInput}
                      onChange={(e) => handleImageUpload(e, props.title)}
                      type="file"
                      accept={props.title !== 'Create Invoice' ? "image/png, image/gif, image/jpeg" : ".pdf"}
                      className='input_display'
                    />
                  </>
                  <div className='dialog_buttons'>
                    {props.title !== 'Create Invoice' ? <button className="uploadImage-button" onClick={(e) => fileInput.current.click()}><img src={imageThumb} alt="upload" />&nbsp;&nbsp;Upload Image</button> : <></>}
                    {props.title === 'Create Invoice' ? <button className="uploadImage-button" onClick={(e) => fileInput.current.click()}><img src={imageThumb} alt="upload" />&nbsp;&nbsp;Upload Pdf</button> : <></>}
                    <button className="done-button" onClick={props.onSubmit}>{props.buttonLabel ?? "Done"}</button>
                  </div>
                </div>
                :
                <>
                  {showDone ?
                    <div className="dialog__footer flexCol alignItemsCenter">
                      <button disabled={(props.disabled || props.showLoadingBtn) ? (props.disabled || props.showLoadingBtn) : false} className={"done-button" + ((props.disabled || props.showLoadingBtn) ? ' button_inrt' : '')} onClick={props.onSubmit}>{props.buttonLabel ? props.buttonLabel : "Done"}</button>
                    </div>
                    : null}
                </>
              }
            </>
          }
          {props.title === 'Download Cash Deposit Reports' ?
            <div className={`dialog__container_item margTop24`}>
              <div className={`dialog__description flexRow alignItemsCenter justifyContentCenter`}>
                <button type="button" disabled={getDatasetAtEvent(props.children) || props.showLoadingBtn} onClick={(e, updated) => props.onSubmit(e, updated)} className="submit-button-rep1" style={{ color: "white" }}>
                  {!props.showLoadingBtn ? <><span><img className="icon-size" alt='downloadMaster' src={downloadMasterIcon} /></span> Download</> : <><span><img src={LoadingIn} alt='loading' className="icon-size" /> Processing...
                  </span></>}

                </button>
              </div>
            </div>
            : <></>
          }
          {/* </form> */}
        </div>
      </div>
    </div>
  );
}
export const EditModal = (props) => {

  const [editHsn, setEditHsn] = useState("");
  const [updated, setUpdated] = useState(null);
  const [showDimensionInfo, setShowDimensionInfo] = useState(false);
  const dimensionInfoRef = useRef(null);
  const [localFields, setLocalFields] = useState(() =>
    props.fields ? props.fields.map(f => ({ ...f })) : []
  );
  const dimensionAttributes = useRef(new Set([
    'useShapeBasedDimensions',
    'dimensionUnit',
    'shape',
    'weight',
    'length',
    'width',
    'height',
    'diameter',
    'volume',
    'volumeUnit'
  ]));
  const unitStructureAttributes = useRef(new Set([
    'purchaseUnit',
    'purchaseToUpliftQty',
    'upliftUnit',
    'upliftToSalesQty',
    'salesUnit',
    'salesUnitQty',
    'baseUnit',
    'allowFractionalSalesUnit',
    'unit'
  ]));
  useEffect(() => {
    if (!props.fields) return;

    let cloned = props.fields.map(f => ({ ...f }));
    if (props.title === "Add HSN Mapping") {
      cloned[0].disabled = false;
    }

    if (props.title === "Edit Role") {
      cloned[1].disabled = !cloned[1].disabled;
    }

    if (updated) {
      cloned = cloned.map(field => {
        if (typeof field.disabledCheck === "function") {
          field.disabledCheck(updated);
        }
        return field;
      });
    }

    setLocalFields(cloned);
    setEditHsn(props.fields[0]?.initialValue ?? "");
  }, [props.fields, props.title, updated]);

  useEffect(() => {
    if (!showDimensionInfo) return;

    const handleOutsideClick = (event) => {
      if (dimensionInfoRef.current && !dimensionInfoRef.current.contains(event.target)) {
        setShowDimensionInfo(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setShowDimensionInfo(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [showDimensionInfo]);



  const onChangeSelectSearch = (selectedValue, data, selectedObj) => {
    let newUpdates = updated ? { ...updated } : {}
    newUpdates[data.name] = selectedValue;
    newUpdates[data.name + '_id'] = selectedObj.id;
    setUpdated({ ...newUpdates });
    if (props.onChange) {
      typeof (props.onChange) === 'function' && props.onChange(selectedValue, newUpdates, data)
    }
  };

  const onChangeMultiSelect = (selectedValue, data, selectedObj) => {
    let newUpdates = updated ? { ...updated } : {}
    newUpdates[data.attribute] = selectedValue?.label;
    setUpdated({ ...newUpdates });
    if (props.onChange) {
      typeof (props.onChange) === 'function' && data && data.type === "rcSelectAll" ? props.onChange(null, selectedObj, null) : props.onChange(selectedValue, data, null)
    }
  };

  function onChangeSelectSearch2(selectedValue, data) {
    let newUpdates = updated ? { ...updated } : {}
    newUpdates[data.attribute] = selectedValue?.value;
    if (data?.attribute === "warehouse" && updated?.sector) {
      newUpdates.sector = undefined
    }
    setUpdated({ ...newUpdates });
    typeof (props.onChange) === 'function' && props.onChange(null, newUpdates)
  }


  const onChange = (e, data) => {
    const { name, value, checked, type } = e.target;
    let newUpdates = updated ? { ...updated } : {}
    if (e.target.name === "itemType") {
      props.setItemTypeValue(e.target.value);
    };
    if (e.target.name === "img") {
      props.encodeImageFileAsURL(data)
      setUpdated({ ...newUpdates, ...data });
    };
    if (e.target.name === 'targetDate') {
      const { target } = e
      onChangeMultiSelect({}, target, null)
    }

    newUpdates[name] = value;
    if (name === 'dimensionUnit') {
      newUpdates.volumeUnit = CUBIC_VOLUME_UNITS[value] || '';
    }
    if ((checked || !checked) && (type === 'checkbox')) {
      newUpdates[name] = checked;
    }
    if ((type === 'radio')) {
      setUpdated({ ...newUpdates, ...data });
    }
    else {
      setUpdated({ ...newUpdates });
      if (typeof (props.onChange) === 'function') {
        const patchedUpdates = props.onChange(e, newUpdates);
        if (patchedUpdates && typeof patchedUpdates === 'object') {
          setUpdated({ ...patchedUpdates });
        }
      }
    }
  }

  const onSubmit = (e) => {
    const mode = props.title;
    removeContainerOverlay();
    let submittedValues = isItemMasterForm && dimensionUnitField
      ? { ...updated, volumeUnit: volumeUnitValue }
      : updated;
    
    typeof (props.onSubmit) === 'function' && props.onSubmit(e, submittedValues, editHsn, mode)
  }
  // const onFormSubmitHandle = (e) => {
  //   removeContainerOverlay();
  //   typeof (props.onFormSubmitHandle) === 'function' && props.onFormSubmitHandle(e);
  //   return false;
  // }

  const onClose = (e) => {
    removeContainerOverlay();
    props.onClose();
  }

  const removeContainerOverlay = () => {
    /**
     * Remove overlay to parent class
     */
    (document.querySelectorAll('.content-container')[0]).classList.remove('modal-overlay-bg2');
  };

  const renderInputField = (_) => {
    const { initialValue, ...rest } = _;
    return (
      <Input
        key={_.attribute}
        title={props.title}
        name={_.attribute}
        action={_.onSelectAction || null}
        value={updated && updated[_.attribute] !== undefined ? updated[_.attribute] : initialValue !== undefined ? initialValue : ''}
        data={initialValue}
        setIsDropdownOpen={props.setIsDropdownOpen}
        onChange={(e, searchSelectObj = {}, imgFile = null) => {
          if (_.type === 'selectSearch') {
            onChangeSelectSearch(e, _, searchSelectObj);
          } else if (_.type === 'multiSelect' || _.type === 'rcSelectAll') {
            onChangeMultiSelect(e, _, searchSelectObj)
          } else if (_.type === "selectSearch2") {
            onChangeSelectSearch2(e, _)
          }
          else if (_.type === 'radio-split') {
            onChange(e, searchSelectObj);
          }
          else if (imgFile) {
            onChange(e, imgFile);
          }
          else {
            onChange(e, _)
          }
        }}
        {...rest}
      />
    );
  };

  const isItemMasterForm = props.title === 'Edit Item' || props.title === 'Add Item';
  const normalFields = localFields.filter(field => !dimensionAttributes.current.has(field.attribute) && !unitStructureAttributes.current.has(field.attribute));
  const unitStructureFieldsModel = localFields.filter(field => unitStructureAttributes.current.has(field.attribute));
  const dimensionFields = localFields.filter(field => dimensionAttributes.current.has(field.attribute));

  const findUnitStructureField = (name) => unitStructureFieldsModel.find(field => field.attribute === name);
  const purchaseUnitField = findUnitStructureField('purchaseUnit');
  const purchaseToUpliftQtyField = findUnitStructureField('purchaseToUpliftQty');
  const upliftUnitField = findUnitStructureField('upliftUnit');
  const upliftToSalesQtyField = findUnitStructureField('upliftToSalesQty');
  const salesUnitField = findUnitStructureField('salesUnit');
  const salesUnitQtyField = findUnitStructureField('salesUnitQty');
  const baseUnitQtyField = findUnitStructureField('baseUnit');
  const allowFractionalSalesUnitField = findUnitStructureField('allowFractionalSalesUnit');

  const resolveFieldValue = (field, fallback = '') => {
    if (!field) return fallback;
    if (updated && updated[field.attribute] !== undefined) return updated[field.attribute];
    return field.initialValue !== undefined ? field.initialValue : fallback;
  };

  const purchaseQtyValue = Number(resolveFieldValue(purchaseToUpliftQtyField, 1));
  const upliftQtyValue = Number(resolveFieldValue(upliftToSalesQtyField, 1));
  const salesUnitQtyValue = Number(resolveFieldValue(salesUnitQtyField, 1));
  const purchaseLabel = resolveFieldValue(purchaseUnitField, '') || '-';
  const upliftLabel = resolveFieldValue(upliftUnitField, '') || '-';
  const salesLabel = resolveFieldValue(salesUnitField, '') || '-';
  const totalConversionValue = Number.isFinite(purchaseQtyValue) && Number.isFinite(upliftQtyValue) && Number.isFinite(salesUnitQtyValue)
    ? Number((purchaseQtyValue * upliftQtyValue * salesUnitQtyValue).toFixed(4))
    : 0;

  const findDimensionField = (name) => dimensionFields.find(field => field.attribute === name);
  const useShapeField = findDimensionField('useShapeBasedDimensions');
  const shapeField = findDimensionField('shape');
  const weightField = findDimensionField('weight');
  const dimensionUnitField = findDimensionField('dimensionUnit');
  const lengthField = findDimensionField('length');
  const widthField = findDimensionField('width');
  const heightField = findDimensionField('height');
  const diameterField = findDimensionField('diameter');
  const volumeField = findDimensionField('volume');
  const dimensionUnitValue = updated?.dimensionUnit ?? dimensionUnitField?.value ?? dimensionUnitField?.initialValue ?? '';
  const volumeUnitValue = CUBIC_VOLUME_UNITS[dimensionUnitValue] || '';

  const shapeValue = (updated && updated.shape !== undefined && updated.shape !== null)
    ? updated.shape
    : shapeField?.initialValue;

  const useShapeBasedValue = Boolean((updated && updated.useShapeBasedDimensions !== undefined && updated.useShapeBasedDimensions !== null)
    ? updated.useShapeBasedDimensions
    : useShapeField?.initialValue);
  const showDiameterField = shapeValue === 'CYLINDRICAL';

  const triggerParentChange = (name, value, mergedState) => {
    if (typeof props.onChange !== 'function') return;
    const syntheticEvent = {
      target: {
        name,
        value,
        checked: Boolean(value),
        type: name === 'useShapeBasedDimensions' ? 'checkbox' : 'text'
      }
    };
    const patchedUpdates = props.onChange(syntheticEvent, mergedState);
    if (patchedUpdates && typeof patchedUpdates === 'object') {
      setUpdated({ ...patchedUpdates });
      return;
    }
    setUpdated({ ...mergedState });
  };

  const onClearDimensionFields = () => {
    const base = updated ? { ...updated } : {};
    const resetValues = {
      useShapeBasedDimensions: false,
      shape: '',
      dimensionUnit: '',
      length: '',
      width: '',
      height: '',
      diameter: '',
      volume: 0,
      volumeUnit: ''
    };
    const mergedState = { ...base, ...resetValues };
    triggerParentChange('shape', 'BOX', mergedState);
  };

  const onDimensionToggleChange = (e) => {
    onChange(e, useShapeField || { attribute: 'useShapeBasedDimensions' });
  };

  const onDimensionInfoToggle = () => {
    setShowDimensionInfo(prev => !prev);
  };

  return (
    <Modal
      showDone={props.showDone}
      className={props.className}
      isSubModal={props.isSubModal}
      columnViewType={props.columnViewType}
      title={props.title}
      customModalStyle={props.customModalStyle ? props.customModalStyle : undefined}
      customContentHeight={props.customContentHeight ? props.customContentHeight : undefined}
      onClose={onClose}
      encodeImageFileAsURL={props.encodeImageFileAsURL}
      blobFile={props.blobFile}
      fileUpload={props.fileUpload}
      imageUrl={props.imageUrl}
      selectedOptions={props.selectedOptions}
      setSlectedOptions={props.setSelectedOptions}
      buttonLabel={props.buttonLabel}
      disabled={props.disabled}
      modalCustomButtons={props.modalCustomButtons || []}
      onChange={onChange}
      resetImageSelection={props.resetImageSelection}
      showFieldsInColumn={props.showFieldsInColumn}
      onSubmit={(e) => onSubmit(e)}
      showLoadingBtn={props.showLoadingBtn || null}
      mainContentCenter={props.mainContentCenter || null}
      alignStart={props.alignStart || null}
      // onFormSubmitHandle={(e) => {
      //   return onFormSubmitHandle(e);
      // } }
      modalFormStatusObj={props.modalFormStatusObj}>
      {
        props && props.fields && normalFields?.map((_) => {
          if (_.type === 'heading' && props.className === 'airports-modal') {
            return (
              <div
                key={_.attribute}
                className="form-section-heading"
              >
                <h3>{_.label}</h3>
              </div>
            );
          }
          return renderInputField(_)
        })
      }

      {isItemMasterForm && unitStructureFieldsModel.length > 0 && purchaseUnitField && (
        <div className="item-unit-structure-card width100">
          <div className="item-unit-structure-card__header">
            <div className="item-unit-structure-card__title">Unit Structure</div>
            <div className="item-unit-structure-card__subtitle">Define Purchase (PO & GRN), Uplift and Sales (Sales Order) units with conversion values.</div>
          </div>

          <div className="item-unit-structure-card__grid item-unit-structure-card__grid--levels">
            <div className="item-unit-structure-card__field">{purchaseUnitField ? renderInputField(purchaseUnitField) : null}</div>
            <div className="item-unit-structure-card__field">{purchaseToUpliftQtyField ? renderInputField(purchaseToUpliftQtyField) : null}</div>
            <div className="item-unit-structure-card__field">{upliftUnitField ? renderInputField(upliftUnitField) : null}</div>
            <div className="item-unit-structure-card__field">{upliftToSalesQtyField ? renderInputField(upliftToSalesQtyField) : null}</div>
          </div>

          <div className="item-unit-structure-card__grid item-unit-structure-card__grid--sales">
            <div className="item-unit-structure-card__field">{salesUnitField ? renderInputField(salesUnitField) : null}</div>
            <div className="item-unit-structure-card__field">{salesUnitQtyField ? renderInputField(salesUnitQtyField) : null}</div>
            <div className="item-unit-structure-card__field">{baseUnitQtyField ? renderInputField(baseUnitQtyField) : null}</div>
          </div>

          <div className="item-unit-structure-card__grid item-unit-structure-card__grid--fractional">
            <div className="item-unit-structure-card__field item-unit-structure-card__checkbox">{allowFractionalSalesUnitField ? renderInputField(allowFractionalSalesUnitField) : null}</div>
          </div>

          <div className="item-unit-structure-card__summary">
            1 {purchaseLabel} = {purchaseQtyValue || 0} {upliftLabel}; 1 {upliftLabel} = {upliftQtyValue || 0} {salesLabel}; sales factor = {salesUnitQtyValue || 0}; total conversion: 1 {purchaseLabel} = {totalConversionValue} {salesLabel}
          </div>
        </div>
      )}
      {isItemMasterForm && dimensionFields.length > 0 && (
        <div className="item-dimension-card width100">
          <div className="item-dimension-card__header flexRow justifyContentSpaceBetween alignItemsCenter width100">
            <div className="item-dimension-card__title flexRow alignItemsCenter">
              <span>Dimensions & Volume</span>
              <div className="item-dimension-card__info-wrap" ref={dimensionInfoRef}>
                <button
                  type="button"
                  className="item-dimension-card__info"
                  onClick={onDimensionInfoToggle}
                  aria-label="How to fill dimensions and volume"
                  aria-expanded={showDimensionInfo}
                >
                  i
                </button>
                {showDimensionInfo && (
                  <div className="item-dimension-card__tooltip" role="tooltip">
                    <div className="item-dimension-card__tooltip-title">How to handle different types of dimensions</div>
                    <p>
                      Dimensions can vary based on item shape (for example, box vs cylindrical). Use the guidance below to fill this section correctly.
                    </p>
                    <div className="item-dimension-card__tooltip-subtitle">A. Standard Cuboid approach (Recommended)</div>
                    <ul>
                      <li>Dimension Unit: select cm, inch, or mm.</li>
                      <li>L, W, H: enter numeric values for Length, Width, and Height.</li>
                      <li>Volume: auto-calculated (L x W x H) for regular shapes, but can be manually overridden when needed.</li>
                    </ul>
                    <div className="item-dimension-card__tooltip-subtitle">B. Shape-Based toggle</div>
                    <ul>
                      <li>If Box: fill Length, Width, Height.</li>
                      <li>If Cylindrical: fill Diameter and Height.</li>
                      <li>If Irregular: enter Total Volume only.</li>
                    </ul>
                    <div className="item-dimension-card__tooltip-subtitle">C. Handling units</div>
                    <ul>
                      <li>Use Dimension Unit for size measurements only.</li>
                      <li>Use Volume Unit for volume values only.</li>
                      <li>Weight and sales/stock unit should remain separate from dimensions units.</li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="item-dimension-card__actions flexRow alignItemsCenter">
              <label className="item-dimension-card__toggle flexRow alignItemsCenter">
                
                <input
                  type="checkbox"
                  name="useShapeBasedDimensions"
                  checked={useShapeBasedValue}
                  onChange={onDimensionToggleChange}
                />
                <span>Use Shape Based Dimensions</span>
              </label>
              <button type="button" className="item-dimension-card__clear" onClick={onClearDimensionFields}>Clear</button>
            </div>
          </div>

          <div className="item-dimension-card__groups">
            <div className="item-dimension-card__group item-dimension-card__group--unit">
              <div className="item-dimension-card__field item-dimension-card__field--unit">
                {dimensionUnitField ? renderInputField(dimensionUnitField) : null}
                {(shapeValue === 'BOX' || shapeValue === 'CYLINDRICAL') && (
                  <div className="item-dimension-card__unit-visual">
                    <img
                      src={shapeValue === 'CYLINDRICAL' ? dimensionCylindrical : dimensionCuboid}
                      alt={shapeValue === 'CYLINDRICAL' ? 'Cylindrical dimension guide' : 'Box dimension guide'}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="item-dimension-card__group item-dimension-card__group--measures">
              <div className="item-dimension-card__measure-grid">
                <div className="item-dimension-card__field">{lengthField ? renderInputField(lengthField) : null}</div>
                <div className="item-dimension-card__field">{widthField ? renderInputField(widthField) : null}</div>
                <div className="item-dimension-card__field">{heightField ? renderInputField(heightField) : null}</div>
                {showDiameterField && (
                  <div className="item-dimension-card__field">{diameterField ? renderInputField(diameterField) : null}</div>
                )}
              </div>
              <div className="item-dimension-card__hint">Auto-calculated volume based on the selected shape. You can override the value if needed.</div>
              <div className="item-dimension-card__shape-row">
                <div className="item-dimension-card__shape">{shapeField ? renderInputField(shapeField) : null}</div>
                <div className="item-dimension-card__shape">{weightField ? renderInputField(weightField) : null}</div>
              </div>
            </div>

            <div className="item-dimension-card__group item-dimension-card__group--volume">
              <div className="item-dimension-card__volume-grid">
                <div className="item-dimension-card__volume-value">
                  <div className="item-dimension-card__field">{volumeField ? renderInputField(volumeField) : null}</div>
                  <span className="item-dimension-card__volume-unit" aria-label="Cubic volume unit">
                    {volumeUnitValue && <>{dimensionUnitValue}<sup>3</sup></>}
                  </span>
                </div>
                <input type="hidden" name="volumeUnit" value={volumeUnitValue} />
              </div>
              <div className="item-dimension-card__about">
                <div className="item-dimension-card__about-title">About Dimensions</div>
                <ul>
                  <li>Box (Cuboid): Length, Width, Height</li>
                  <li>Cylindrical: Diameter, Height</li>
                  <li>Irregular: Total Volume only</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {props.children}
    </Modal>
  )
}